(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5280],{

/***/ 54830:
/***/ (function(module) {


;(function (name, root, factory) {
  if (true) {
    module.exports = factory()
    module.exports["default"] = factory()
  }
  /* istanbul ignore next */
  else {}
}('slugify', this, function () {
  var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E\'","Ը":"Y\'","Թ":"T\'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C\'","Կ":"K","Հ":"H","Ձ":"D\'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R\'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P\'","Ք":"Q\'","Օ":"O\'\'","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","„":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}')
  var locales = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}')

  function replace (string, options) {
    if (typeof string !== 'string') {
      throw new Error('slugify: string argument expected')
    }

    options = (typeof options === 'string')
      ? {replacement: options}
      : options || {}

    var locale = locales[options.locale] || {}

    var replacement = options.replacement === undefined ? '-' : options.replacement

    var trim = options.trim === undefined ? true : options.trim

    var slug = string.normalize().split('')
      // replace characters based on charMap
      .reduce(function (result, ch) {
        var appendChar = locale[ch] || charMap[ch] || ch;
        if (appendChar === replacement) {
          appendChar = ' ';
        }
        return result + appendChar
          // remove not allowed characters
          .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, '')
      }, '');

    if (options.strict) {
      slug = slug.replace(/[^A-Za-z0-9\s]/g, '');
    }

    if (trim) {
      slug = slug.trim()
    }

    // Replace spaces with replacement character, treating multiple consecutive
    // spaces as a single space.
    slug = slug.replace(/\s+/g, replacement);

    if (options.lower) {
      slug = slug.toLowerCase()
    }

    return slug
  }

  replace.extend = function (customMap) {
    Object.assign(charMap, customMap)
  }

  return replace
}))


/***/ }),

/***/ 25:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var memoizee__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37453);
/* harmony import */ var memoizee__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(memoizee__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69468);
/* harmony import */ var _utils_cloneChildren__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91048);





const getTransitionStyles = (state)=>({
        entering: {
            opacity: 0
        },
        entered: {
            opacity: 1
        },
        exiting: {
            opacity: 1
        },
        exited: {
            opacity: 0
        },
        unmounted: {
            opacity: 0
        }
    })[state];
const cloneChildrenWithStyles = memoizee__WEBPACK_IMPORTED_MODULE_1___default()((state, children, duration)=>(0,_utils_cloneChildren__WEBPACK_IMPORTED_MODULE_3__/* .cloneChildren */ .v)(children, (param)=>{
        let { props  } = param;
        return {
            style: {
                transition: "opacity ".concat(duration, "ms ease-in-out"),
                ...getTransitionStyles(state),
                ...props.style || {}
            }
        };
    }));
const Fade = (param)=>{
    let { duration =150 , children , timeout =0 , ...transitionProps } = param;
    const transitionRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_transition_group__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        nodeRef: transitionRef,
        timeout: timeout,
        ...transitionProps,
        children: (state)=>cloneChildrenWithStyles(state, children, duration)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.memo(Fade));


/***/ }),

/***/ 15897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);
/* harmony import */ var src_components_common_Carbon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29946);
/* harmony import */ var _SectionHeader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9978);





const AboutUs = (param)=>{
    let { hideStory  } = param;
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)();
    const data = [
        !hideStory && {
            tag: i18n.t("Founded in 2015"),
            header: i18n.t("Our story"),
            paragraphs: [
                i18n.t("Combining smart technology with modern, welcoming clinics, Carbon Health delivers a uniquely seamless experience — with virtual and in-person appointments, primary care, urgent care, and mental healthcare — to meet you where you are. We aim to make the exceptional expected."),
                i18n.t("We’re removing traditional boundaries in healthcare, to make high-quality, transparent, and personal care accessible — because great care should always be within reach, no matter who or where you are.")
            ]
        },
        {
            tag: i18n.t("What we believe"),
            header: i18n.t("Our culture"),
            paragraphs: [
                i18n.t("At Carbon Health, we believe in the power of health, of medicine, and of technology. We aim to create a supportive environment where you can develop your career and continually refine your craft, whether you work in one of our clinics or with the team at Carbon Health headquarters."),
                i18n.t("We hire people who genuinely care. In doing so, we’ve built a diverse and passionate team of employees who are all driven to learn from one another and support Carbon Health’s mission of bringing high-quality healthcare to everyone.")
            ]
        }
    ].compact();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "ph8 pt30 pt12-sm pb10 pos-r",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_common_Carbon__WEBPACK_IMPORTED_MODULE_3__/* .V5Img */ .fH, {
                className: "pos-a right0 h140 dn-md",
                style: {
                    bottom: -30
                },
                src: "/illustrations/squiggly-lines"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "maxw80 ma",
                children: data.map((section, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "df fdc mb".concat(i === data.length - 1 ? "20" : "30"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SectionHeader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                tag: section.tag,
                                header: section.header
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "df fdc-sm font-cm font-ir-sm jcsb maxw70 fs20 mt16 fs16-xs",
                                children: section.paragraphs.map((p)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "fx maxw28 mr10 mr0-sm mb10 mb5-xs",
                                        children: p
                                    }, p.slice(0, 10)))
                            })
                        ]
                    }, section.tag))
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AboutUs);


/***/ }),

/***/ 3497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ About_Careers; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@c10h/colors/es/palette.js
var palette = __webpack_require__(45602);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
// EXTERNAL MODULE: ./src/components/v5/V5Comp.tsx
var V5Comp = __webpack_require__(63575);
// EXTERNAL MODULE: ./src/components/_common/Carbon.tsx
var Carbon = __webpack_require__(29946);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
// EXTERNAL MODULE: ./src/useMediaQuery.ts
var useMediaQuery = __webpack_require__(57974);
;// CONCATENATED MODULE: ./src/components/v5/About/JobGroupCard.tsx








const JobGroupCard = (param)=>{
    let { name , zIndex , jobs , backgroundColor , backgroundImage , color  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { isMobile  } = (0,store/* useTypedSelector */.ix)((state)=>state.config);
    const [showTeams, setShowTeams] = (0,react.useState)(false);
    const isXs = (0,useMediaQuery/* default */.Z)("xs");
    const leverDeptUrl = "".concat(_constants/* careersUrl */.j8, "?department=").concat(name.replace("&", "%26"));
    const teams = jobs.distinctBy((job)=>job.categories.team).map((job)=>job.categories.team);
    const extraTeams = Math.max(teams.length - 6, 0);
    const toggleShowTeams = (boolean)=>()=>{
            setShowTeams(typeof boolean === "boolean" ? boolean : !showTeams);
        };
    const expandedHeight = extraTeams * 6.3 + 100 - (name.length < 19 ? 10 : 0);
    const wrapperProps = {
        href: isMobile ? null : leverDeptUrl,
        className: "pos-r ph4 pt3 pb2 mb2 mb5-xs mr2 mr0-xs minh72 minh minh36-xs mh0-xs br2 cp t-300 oh df aife w72 w100p-f-xs",
        style: {
            backgroundColor,
            height: showTeams ? "".concat(expandedHeight, "%") : "0%",
            maxHeight: 278 + (showTeams && extraTeams ? 500 : 0),
            transform: showTeams && !isXs ? "scale(1.04)" : null
        },
        onClick: toggleShowTeams(),
        onMouseEnter: toggleShowTeams(true),
        onFocus: toggleShowTeams(true),
        onMouseLeave: toggleShowTeams(false),
        onBlur: toggleShowTeams(false)
    };
    const children = [
        /*#__PURE__*/ (0,jsx_runtime.jsx)(Carbon/* V5Img */.fH, {
            className: "pos-a top0 right0 zIndex0 t-300 ".concat(showTeams ? "op0" : "op1"),
            src: "/illustrations/".concat(backgroundImage, ".webp")
        }, "pattern-".concat(leverDeptUrl)),
        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "df pos-r fdc h100p jcfe zIndex2 t-300",
            style: {
                bottom: showTeams || !isXs ? 0 : -10
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    className: "mb2 fs24 gray800 ls-3 font-cm fw5 lh13",
                    children: name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "ttu mb2 font-mb fs12",
                    style: {
                        color
                    },
                    children: i18n.t("{{count}} roles", {
                        count: jobs.length
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mv2 t-300 oh df fdc jcsb jcfs-xs",
                    style: {
                        height: showTeams ? "100%" : "0%",
                        maxHeight: showTeams ? 500 : 0
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "font-ir fs14 mb4",
                            children: teams.map((team)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "lh13 gray800",
                                    children: team
                                }, team))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(V5Comp/* Btn */.un, {
                            fontSize: 0.7,
                            hoverBg: backgroundColor,
                            hover: color,
                            ...isXs ? {
                                href: leverDeptUrl,
                                className: "focus-bsDarkBlue3-hug"
                            } : {
                                tabIndex: -1,
                                type: "button"
                            },
                            children: [
                                i18n.t("View These Roles"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "cIcon-arrow-45deg fs8-f ml2",
                                    "aria-hidden": true
                                })
                            ]
                        })
                    ]
                })
            ]
        }, "content-".concat(leverDeptUrl))
    ];
    // For valid DOM nesting
    const content = /*#__PURE__*/ react.createElement(isMobile ? "div" : "a", wrapperProps, children);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pos-r maxw25 minw100p-xs h72 minh30-xs hfc-xs mr3 mr0-xs mb5 mb0-xs",
        style: {
            zIndex
        },
        children: content
    });
};
/* harmony default export */ var About_JobGroupCard = (JobGroupCard);

// EXTERNAL MODULE: ./src/components/v5/About/SectionHeader.tsx
var SectionHeader = __webpack_require__(9978);
;// CONCATENATED MODULE: ./src/components/v5/About/Careers.tsx








const colorImageRotation = [
    {
        backgroundColor: palette.lightGreen,
        color: palette.darkerGreen,
        backgroundImage: "pattern-0"
    },
    {
        backgroundColor: palette.lightBlue,
        color: palette.darkerBlue,
        backgroundImage: "pattern-1"
    },
    {
        backgroundColor: palette.lightYellow,
        color: palette.darkerYellow,
        backgroundImage: "pattern-2"
    },
    {
        backgroundColor: palette.lightRed,
        color: palette.darkerRed,
        backgroundImage: "pattern-3"
    },
    {
        backgroundColor: palette.lightPurple,
        color: palette.darkerPurple,
        backgroundImage: "pattern-4"
    },
    {
        backgroundColor: palette.lightMint,
        color: palette.darkerMint,
        backgroundImage: "pattern-5"
    }
];
const getColorOption = (i)=>Object.assign(colorImageRotation[i % colorImageRotation.length], i % 6 === 0 && !(i % 12 === 0) ? {
        backgroundImage: "pattern-6"
    } : {});
const Careers = (param)=>{
    let { jobs  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const jobsByDepartment = jobs.groupBy((job)=>job.categories.department);
    const jobsByDepartmentArray = jobsByDepartment.getKeys().map((key)=>({
            name: key,
            jobs: jobsByDepartment[key]
        }));
    const strings = {
        tag: i18n.t("Join Our Team"),
        header: i18n.t("We're hiring for {{count}} roles", {
            count: jobs.length
        }),
        p1: i18n.t("We’re a global team of top healthcare providers and experts in a wide range of fields —  working to improve how patients and providers experience healthcare."),
        p2: i18n.t("We’re passionate about our mission, and we’re hiring throughout the company.")
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "careers",
        className: "ph8 ph5-xs pv24 pv16-sm",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "maxw80 ma",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "df fdc-md jcsb jcfs-md pb18 pb4-md maxw72",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "df fdc jcsb",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader/* default */.Z, {
                                    className: "fx mr4 mb4",
                                    tag: strings.tag,
                                    header: strings.header
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "minh14 minh0-md",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(V5Comp/* Btn */.un, {
                                        fontSize: 0.75,
                                        href: _constants/* careersUrl */.j8,
                                        className: "event-fj1Dgn zIndex3 mb3 focus-bsDarkBlue3",
                                        children: [
                                            i18n.t("View All Open Positions"),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cIcon-arrow-45deg fs8-f ml2",
                                                "aria-hidden": true
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "fx2 fs20 mb7-xs mt2 fs18-sm maxw35",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "font-cm mb6",
                                    children: strings.p1
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "font-csb",
                                    children: strings.p2
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "df fw",
                    children: jobsByDepartmentArray.map((dept, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(About_JobGroupCard, {
                            zIndex: jobsByDepartmentArray.length - i,
                            name: dept.name,
                            jobs: dept.jobs,
                            ...getColorOption(i)
                        }, dept.name))
                })
            ]
        })
    });
};
/* harmony default export */ var About_Careers = (Careers);


/***/ }),

/***/ 77544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _c10h_colors__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(45602);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70356);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32466);
/* harmony import */ var react_scrollmagic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84690);
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54830);
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(slugify__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var src_components_common_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93932);
/* harmony import */ var src_components_common_Carbon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29946);
/* harmony import */ var src_store__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40367);
/* harmony import */ var src_useMediaQuery__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57974);
/* harmony import */ var _animations_Fade__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(25);
/* harmony import */ var _NextImage__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5621);
/* eslint-disable react/no-unstable-nested-components */ 












const CoreValues = ()=>{
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    const [activeIndex, setActiveIndex] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0);
    const { height =1000  } = (0,src_components_common_Carbon__WEBPACK_IMPORTED_MODULE_7__/* .useWindowSize */ .fy)();
    const [componentHeight, setComponentHeight] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(1000);
    const { isMobile  } = (0,src_store__WEBPACK_IMPORTED_MODULE_8__/* .useTypedSelector */ .ix)((state)=>state.config);
    const data = [
        {
            bgColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_12__.lightGreen,
            header: i18n.t("We assume karma exists"),
            text: i18n.t("Assume that doing the right things consistently will yield disproportionate rewards, even if you can’t always tell how that will happen."),
            image: "/illustrations/man-planting-tree_",
            alt: i18n.t("Illustration of a person kneeling and planting a tree seedling outside")
        },
        {
            bgColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_12__.lightBlue,
            header: i18n.t("We respect the craft"),
            text: i18n.t("Value the collective wisdom that’s been accumulated by people who have been doing a particular job for a long time."),
            image: "/illustrations/people-watering-tree",
            alt: i18n.t("Illustration of three people working together to care for a young tree")
        },
        {
            bgColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_12__.lightYellow,
            header: i18n.t("We put ourselves in\npositions of insight"),
            text: i18n.t("Unique insight, which often comes from a position of direct observation, is the reason the Davids of the world can compete with the Goliaths."),
            image: "/illustrations/woman-sitting-by-tree",
            alt: i18n.t("Illustration of a person sitting and thinking beneath the shade of a tree")
        },
        {
            bgColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_12__.lightPurple,
            header: i18n.t("We hire people who genuinely care"),
            text: i18n.t("There’s no replacement for having people who care deeply about solving the problem we’re hiring them to solve."),
            image: "/illustrations/people-standing-under-tree",
            heightFactor: 1.3,
            alt: i18n.t("Illustration of a large group of people gardening together beneath a large tree")
        }
    ];
    const activeItem = data[activeIndex];
    const toggleActiveIndex = (i)=>lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default()(()=>{
            setActiveIndex(i);
        }, 150);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        setComponentHeight(5000 - height);
    }, [
        height
    ]);
    const isSm = (0,src_useMediaQuery__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)("sm");
    // @ts-expect-error TS7031, TS7031: Binding element 'item' implicitly has an 'any' type.,  Binding element 'i' implicitly has an 'any' type.
    const Item = (param)=>/*#__PURE__*/ {
        let { item , i , isActive =true  } = param;
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: isActive ? "minh48" : "dn minh48",
            onMouseEnter: toggleActiveIndex(i),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "t-200 mb4 fs28-sm tal-xs",
                    children: item.header
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "t-200 fs20 fs18-sm maxw40 tal-xs",
                    children: item.text
                })
            ]
        }, item.header);
    };
    return isSm ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        id: slugify__WEBPACK_IMPORTED_MODULE_5___default()(data[0].header),
        className: "mv20 bg-lightGreen",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                className: "fs48 font-csb ph8 pt14 lh12",
                children: i18n.t("Our core values")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "m0 p0 df fdc",
                children: data.map((item, i)=>{
                    var _data_;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "ph8 pv10",
                        style: {
                            backgroundColor: item.bgColor
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "df mr20 ma mt3 mb3",
                                children: data.map((item, innerI)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: "#".concat(slugify__WEBPACK_IMPORTED_MODULE_5___default()(item.header)),
                                        className: "mr7 mb5 cp font-ib focus-bsDarkBlue3",
                                        onClick: toggleActiveIndex(innerI),
                                        style: {
                                            color: i === innerI ? _c10h_colors__WEBPACK_IMPORTED_MODULE_12__.gray800 : _c10h_colors__WEBPACK_IMPORTED_MODULE_12__.gray800 + 60
                                        },
                                        children: [
                                            "0",
                                            innerI + 1
                                        ]
                                    }, item.bgColor))
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Item, {
                                i: i,
                                item: item
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NextImage__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                className: "obfc w80 mt14",
                                src: item.image,
                                alt: item.alt,
                                height: 200 * (item.heightFactor || 1),
                                width: 200
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                id: slugify__WEBPACK_IMPORTED_MODULE_5___default()(((_data_ = data[i + 1]) === null || _data_ === void 0 ? void 0 : _data_.header) || "")
                            })
                        ]
                    }, item.header);
                })
            })
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_scrollmagic__WEBPACK_IMPORTED_MODULE_4__/* .Controller */ .Q, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_scrollmagic__WEBPACK_IMPORTED_MODULE_4__/* .Scene */ .x, {
            enabled: !isMobile,
            triggerHook: 0.4,
            indicators: src_components_common_constants__WEBPACK_IMPORTED_MODULE_6__/* .dev */ .WI,
            offset: 20,
            duration: componentHeight + 600,
            children: (progress, event)=>{
                if (event.state === "DURING") {
                    if (progress < 0.25) {
                        setActiveIndex(0);
                    } else if (progress < 0.5) {
                        setActiveIndex(1);
                    } else if (progress < 0.75) {
                        setActiveIndex(2);
                    } else {
                        setActiveIndex(3);
                    }
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "t-1000 pt48 pb100 ph8",
                    style: {
                        backgroundColor: activeItem.bgColor
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "maxw80 ma pos-r df",
                        style: {
                            height: componentHeight
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "fx zIndex0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "pos-sticky",
                                    style: {
                                        top: 500
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "fs60 font-cb ml24 mb30 dn-lg wsnw",
                                            children: i18n.t("Our Core Values")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "df aic",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "df fdc mr20 mr6-md ma mt3",
                                                    children: data.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            className: "mb5 font-ib",
                                                            style: {
                                                                color: i === activeIndex ? _c10h_colors__WEBPACK_IMPORTED_MODULE_12__.gray800 : _c10h_colors__WEBPACK_IMPORTED_MODULE_12__.gray800 + 60
                                                            },
                                                            children: [
                                                                "0",
                                                                i + 1
                                                            ]
                                                        }, item.bgColor))
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    children: data.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_animations_Fade__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                            in: i === activeIndex,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Item, {
                                                                item: item,
                                                                i: i,
                                                                isActive: i === activeIndex
                                                            })
                                                        }, item.header))
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "fx pos-r df fdc aife jcsb ma mt20",
                                style: {
                                    height: "102%"
                                },
                                children: data.map((opt, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_animations_Fade__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        in: i === activeIndex,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NextImage__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                            className: "obfc w80-md",
                                            src: opt.image,
                                            height: 400 * (opt.heightFactor || 1),
                                            width: 400,
                                            alt: opt.alt
                                        })
                                    }, opt.image))
                            })
                        ]
                    })
                });
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CoreValues);


/***/ }),

/***/ 4448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);
/* harmony import */ var _IllustratedTextDecoration__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46452);
/* harmony import */ var _V5Comp__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63575);





const Hero = (param)=>{
    let { jobCount , h1 , subheader , img , alt , caption , backgroundPosition  } = param;
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_V5Comp__WEBPACK_IMPORTED_MODULE_4__/* .ImgWithBg */ .Zx, {
        id: "hero",
        bgImage: img || "/woman-with-phone",
        alt: alt,
        style: {
            backgroundPosition
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "h100p w100p pt100 pt70-xs ph8 ph5-xs pb40 pb14-xs pos-r",
            style: {
                background: "linear-gradient(230deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.6) 100%"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "maxw80 ma df fdc white",
                    children: [
                        Boolean(jobCount) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "df aic mb6 mb3-xs",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "mr3 font-ir fs14",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ni18n__WEBPACK_IMPORTED_MODULE_1__/* .Trans */ .cC, {
                                        count: jobCount,
                                        children: [
                                            "We're hiring for ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("b", {
                                                children: [
                                                    {
                                                        count: jobCount
                                                    },
                                                    " roles"
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_V5Comp__WEBPACK_IMPORTED_MODULE_4__/* .Btn */ .un, {
                                    id: "button",
                                    fontSize: 0.75,
                                    className: "event-rM9BvY focus-bsDarkBlue3",
                                    href: "#careers",
                                    "aria-label": i18n.t("Click to view available job openings."),
                                    children: i18n.t("View Openings")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mb6",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    className: "fs60 fs40-md fs36-sm fs32-xs maxw60 maxw40-md maxw36-sm maxw22-xs",
                                    children: h1 || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ni18n__WEBPACK_IMPORTED_MODULE_1__/* .Trans */ .cC, {
                                        children: [
                                            "Making high-quality healthcare more accessible to",
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "pos-r",
                                                children: [
                                                    "everyone.",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_IllustratedTextDecoration__WEBPACK_IMPORTED_MODULE_3__/* .IllustratedTextDecoration */ .S, {
                                                        type: "underline"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                subheader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "fs18 font-cm ls-3 maxw26",
                                    children: subheader
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "#our-story",
                            id: "our-story",
                            className: "event-rM9BvY focus-bsDarkBlue3 wfc",
                            "aria-label": i18n.t("Click to navigate to the next section."),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "cIcon-arrow-down white fs40 fs30-sm fs24-xs"
                            })
                        })
                    ]
                }),
                caption && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "pos-a dn-md",
                    style: {
                        right: 30,
                        bottom: 30
                    },
                    children: caption
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Hero);


/***/ }),

/***/ 9978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);


const SectionHeader = (param)=>/*#__PURE__*/ {
    let { tag , header , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        ...props,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "ttu font-im fs13",
                style: {
                    letterSpacing: 3
                },
                children: tag
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "mt3 fs48 maxw25",
                children: header
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SectionHeader);


/***/ }),

/***/ 46452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ IllustratedTextDecoration; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var src_useV5ImgSrc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52299);



const IllustratedTextDecoration = (param)=>/*#__PURE__*/ {
    let { type , style , className , width ="100%" , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_useV5ImgSrc__WEBPACK_IMPORTED_MODULE_2__/* .V5Image */ .dZ, {
        style: {
            bottom: type === "circle" ? 1 : -14,
            ...style
        },
        src: "home/word-".concat(type),
        imgExt: "webp",
        className: "pos-a-center right0 left0 ma maxw-none zIndex-1 ".concat(className),
        width: width,
        ...props,
        alt: ""
    });
};


/***/ }),

/***/ 91048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ cloneChildren; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);

const cloneChildren = (children, getNewProps)=>react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, (child, i)=>{
        if (react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child)) {
            return react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(child, getNewProps(child, i));
        }
        return child;
    });


/***/ })

}]);